/*eslint-disable*/
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import OptionsIcon from 'assets/icons/options-icon'

import { StyledActionsMenu, ActionMenuContainer, ActionMenuDropdownMenuContainer } from './style'
import ActionDropdownMenu from './ActionDropdownMenu'

// Only one ActionsMenu may be open at a time. The trigger's onClick calls
// stopPropagation, so the document-level outside-click listeners of the *other*
// mounted menus never fire — without this registry every opened menu stays open.
const openMenuClosers = new Set()

export const closeOtherActionMenus = (keep) => {
  openMenuClosers.forEach((close) => {
    if (close !== keep) {
      close()
    }
  })
}

const ActionsMenu = ({ dropdownItems = [], margin = '0 10px 0 10px', table = true, manageCo = false }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  const [upward, setUpward] = useState(false)
  const actionDropdownMenu = useRef()
  const dropdownRef = useRef()

  const closeMenu = useCallback(() => {
    setIsOpen(false)
  }, [])

  useEffect(() => {
    openMenuClosers.add(closeMenu)
    return () => {
      openMenuClosers.delete(closeMenu)
    }
  }, [closeMenu])

  const closeDropDownMenuOnOutsideClick = (e) => {
    const inTrigger = actionDropdownMenu.current?.contains(e.target)
    const inDropdown = dropdownRef.current?.contains(e.target)
    if (!inTrigger && !inDropdown) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', closeDropDownMenuOnOutsideClick)
    return () => {
      document.removeEventListener('click', closeDropDownMenuOnOutsideClick)
    }
  }, [])

  function openMenu(e) {
    e.stopPropagation()
    e.preventDefault()

    // Clicking the trigger of an open menu closes it.
    if (isOpen) {
      setIsOpen(false)
      return
    }

    const trigger = e.currentTarget?.getBoundingClientRect?.()
    if (!trigger) {
      return
    }

    const ESTIMATED_DROPDOWN_HEIGHT = 240
    const spaceBelow = window.innerHeight - trigger.bottom
    const showAbove = spaceBelow < ESTIMATED_DROPDOWN_HEIGHT
    const topCalculated = showAbove
      ? Math.ceil(trigger.top) - 4
      : Math.ceil(trigger.bottom) + 4

    setPosition({
      top: topCalculated,
      left: Math.ceil(trigger.right)
    })
    setUpward(showAbove)

    if (dropdownItems.length) {
      closeOtherActionMenus(closeMenu)
      setIsOpen(true)
    }
  }

  const dropdown = isOpen && dropdownItems.length > 0
    ? (
      <ActionMenuDropdownMenuContainer
        ref={dropdownRef}
        data-testid='test-dropdown-action-menu'
        position={position}
        table={table}
        manageCo={manageCo}
        active={isOpen}
        upward={upward}
        $portal={table}
      >
        <ActionDropdownMenu closeMenu={closeMenu} dropdownItems={dropdownItems} />
      </ActionMenuDropdownMenuContainer>
    )
    : null

  return (
    <ActionMenuContainer data-testid='test-action-menu' ref={actionDropdownMenu} margin={margin}>
      <StyledActionsMenu isActive={isOpen} onClick={openMenu} type="button">
        <OptionsIcon />
      </StyledActionsMenu>
      {table && typeof document !== 'undefined'
        ? createPortal(dropdown, document.body)
        : dropdown}
    </ActionMenuContainer>
  )
}

export default ActionsMenu
